export const timezoneMapping: Record<string, string> = {
    Eastern: 'America/New_York',
    Central: 'America/Chicago',
    Mountain: 'America/Denver',
    Pacific: 'America/Los_Angeles',
};
